import React, { Component } from "react";
import { Icon } from "@culturehq/components";

import { StoryLink } from "app/links";
import { Trans } from "app/utils";
import notificationFor from "components/notifications/notificationFor";

class NotificationPopup extends Component {
  popupRef = React.createRef();

  componentDidMount() {
    const { notification } = this.props;

    this.popupRef.current.classList.add("notification-popup__show");
    if (notification.notificationType !== "video_story_created") {
      this.timeout = setTimeout(this.handleDismiss, 5000);
    }
  }

  handleDismiss = () => {
    const {
      notification,
      onClose = () => {}
    } = this.props;
    const popup = this.popupRef.current;

    clearTimeout(this.timeout);
    if (popup) {
      popup.classList.remove("notification-popup__show");

      setTimeout(() => {
        popup.classList.add("notification-popup__hide");
        setTimeout(() => onClose(notification), 400);
      }, 25);
    }
  };

  render() {
    const { notification } = this.props;

    return (
      <div className="notification notification-popup" ref={this.popupRef}>
        {notificationFor(notification, 0, this.handleDismiss)}
        {notification.notificationType === "video_story_created" && (
          <StoryLink className="notification-popup__view-link" story={notification.entity} tabIndex={0} dismiss={this.handleDismiss}>
            <Trans>View Story</Trans>
          </StoryLink>
        )}
        <button
          type="button"
          className="notification-popup__close"
          onClick={this.handleDismiss}
        >
          <Icon icon="close" />
        </button>
      </div>
    );
  }
}

export default NotificationPopup;
